import { ExternalChartComponentProps } from '../../data-viz-containers/common/types';
import {
  KpiFactboxTwoMetricViz,
  KpiFactboxTwoMetricVizProps,
} from '../../data-viz-containers/kpi-factbox-two-metric/TwoMetricKpiFactboxViz';
import {
  StoryboardComponentIds,
  StoryboardComponentSettings,
} from '../common/types';
import { FactboxTwoMetricStoryboardComponentConfig } from './types';

const componentConfigToVizContainerProps = (
  componentConfig: FactboxTwoMetricStoryboardComponentConfig,
  externalProps: ExternalChartComponentProps,
  persistenceKey: string
) => {
  return {
    dataConfig: componentConfig.dataConfig,
    selectedView: componentConfig.selectedView,
    externalProps: externalProps,
    persistenceKey: persistenceKey,
  };
};

export const factboxTwoMetricStoryboardComponentSettings: StoryboardComponentSettings<
  FactboxTwoMetricStoryboardComponentConfig,
  KpiFactboxTwoMetricVizProps
> = {
  componentId: StoryboardComponentIds.FACTBOX_TWO_METRIC,
  componentConfigToVizContainerProps: componentConfigToVizContainerProps,
  VizContainerComponent: KpiFactboxTwoMetricViz,
  validateConfig: (componentConfig) => {
    return {
      isValid: true,
      error: null,
    };
  },
};
